export const REFERENCE_MONTH_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

export function isValidReferenceMonth(value: unknown): value is string {
  return typeof value === 'string' && REFERENCE_MONTH_REGEX.test(value);
}

function capitalize(label: string) {
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function formatMonth(monthStr: string) {
  const [year, month] = monthStr.split('-');
  const date = new Date(parseInt(year), parseInt(month) - 1);
  return date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
}

export function formatMonthCapitalized(monthStr: string) {
  return capitalize(formatMonth(monthStr));
}

export function formatCurrency(value: string | number | null | undefined) {
  const num = typeof value === 'string' ? parseFloat(value) : (value ?? 0);
  return (Number.isFinite(num) ? num : 0).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

export function formatDate(value?: string | null) {
  return value ? new Date(value).toLocaleDateString('pt-BR') : '-';
}

export function formatDateTime(value?: string | null) {
  return value ? new Date(value).toLocaleString('pt-BR') : '-';
}

/** Soma `delta` meses a uma competência `YYYY-MM`. */
export function shiftMonth(monthStr: string, delta: number) {
  const [year, month] = monthStr.split('-').map(Number);
  const date = new Date(year, month - 1 + delta, 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
}

export interface MonthOption {
  value: string;
  label: string;
}

/** Últimos 24 meses; inclui `selected` caso esteja fora da janela. */
export function generateMonthOptions(selected?: string): MonthOption[] {
  const options: MonthOption[] = [];
  const now = new Date();
  for (let i = 0; i < 24; i++) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    options.push({ value, label: formatMonthCapitalized(value) });
  }
  if (selected && isValidReferenceMonth(selected) && !options.some((o) => o.value === selected)) {
    return [{ value: selected, label: formatMonthCapitalized(selected) }, ...options];
  }
  return options;
}
